import React, { useLayoutEffect, useRef } from 'react';
import './infographic.scss';
import { lang } from '../lang';

function Infographic() {
  const contentRef = useRef();

  const { stat, number, head, source } = lang.infographic;

  useLayoutEffect(() => {
    const observer = new IntersectionObserver(
      function (entries) {
        entries.forEach((entry) => {
          if (entry.intersectionRatio > 0.1) {
            entry.target.style.animation = 'fade-in 0.5s linear forwards';
          }
        });
      },
      { threshold: [0, 0.1] }
    );

    observer.observe(contentRef.current);
  }, []);

  return (
    <div className="infographic" ref={contentRef}>
      <h3>{head}</h3>
      <div className="infographic__divider" />
      <div className="infographic__content">
        <div className="infographic__row">
          <div className="infographic__row__item">
            <div className="infographic__row__num">{number[0]}</div>
            <p className="infographic__row__copy">{stat[0]}</p>
          </div>
        </div>
        <div className="infographic__row">
          <div className="infographic__row__item">
            <div className="infographic__row__num">{number[1]}</div>
            <p className="infographic__row__copy">{stat[1]}</p>
          </div>
          <div className="infographic__row__item">
            <div className="infographic__row__num">{number[2]}</div>
            <p className="infographic__row__copy">{stat[2]}</p>
          </div>
        </div>
      </div>
      <p className="infographic__source">
        <span className="infographic__source__head">{source[0]}</span>
        {source[1]}
      </p>
    </div>
  );
}

export default Infographic;
